/* Irene Quirós · comportamiento de la versión de evaluación (la ventana de Klaviyo se gestiona en iq-kl.js) */
(function () {
  'use strict';
  var IQ = (window.IQ = window.IQ || {});
  function store(s) {
    return {
      get: function (k) { try { return window[s].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[s].setItem(k, v); } catch (e) {} },
      del: function (k) { try { window[s].removeItem(k); } catch (e) {} }
    };
  }
  var ls = store('localStorage'), ss = store('sessionStorage');
  var tiers = IQ.tiers || [[2, 10], [3, 15], [4, 20]];
  function pctFor(n) { var p = 0; tiers.forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }

  /* En ordenador (Horizon) el desplazamiento ocurre dentro de .page-wrapper, no en la ventana */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && getComputedStyle(pw).overflowY === 'auto') return pw;
    return document.scrollingElement || document.documentElement;
  }
  function fixWindow() {
    var s = scroller();
    if (s !== document.scrollingElement && s !== document.documentElement && window.scrollY) window.scrollTo(0, 0);
  }
  window.addEventListener('load', function () { setTimeout(fixWindow, 60); });
  window.addEventListener('hashchange', function () { setTimeout(fixWindow, 60); });

  /* Reserva simulada del carrito (solo escenario académico, ver sección «Escenario de evaluación») */
  var RKEY = 'iq_reserve_until';
  function newUntil() { return Date.now() + (IQ.reserveMinutes || 10) * 60000; }
  if (IQ.cartCount === 0) ss.del(RKEY);
  if (window.customElements && !customElements.get('iq-reserve')) {
    customElements.define('iq-reserve', class extends HTMLElement {
      connectedCallback() {
        if (!IQ.sim) return;
        var text = this.querySelector('[data-text]');
        if (text && !this.orig) this.orig = text.innerHTML;
        var until = parseInt(ss.get(RKEY) || '0', 10);
        if (!until) { until = newUntil(); ss.set(RKEY, String(until)); }
        this.until = until;
        var self = this;
        clearInterval(this.timer);
        this.tick();
        this.timer = setInterval(function () { self.tick(); }, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      reset(until) {
        this.until = until;
        this.classList.remove('is-expired');
        var text = this.querySelector('[data-text]');
        if (text && this.orig) text.innerHTML = this.orig;
        this.tick();
      }
      tick() {
        this.hidden = false;
        var ms = this.until - Date.now();
        var text = this.querySelector('[data-text]');
        if (ms <= 0) {
          this.classList.add('is-expired');
          if (text && text.textContent !== this.dataset.expired) text.textContent = this.dataset.expired;
          return;
        }
        var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
        var el = this.querySelector('[data-time]');
        if (el) el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }
    });
  }
  function restartReserve() {
    if (!IQ.sim) return;
    var until = newUntil();
    ss.set(RKEY, String(until));
    document.querySelectorAll('iq-reserve').forEach(function (el) { if (el.reset) el.reset(until); });
  }

  /* Título de productos relacionados según el carrito */
  function updateRelated(cart) {
    var sec = document.querySelector('[data-iq-related]');
    if (!sec || !cart) return;
    var pid = parseInt(sec.dataset.productId, 10);
    var inCart = (cart.items || []).some(function (i) { return i.product_id === pid; });
    var n = inCart ? cart.item_count : cart.item_count + 1;
    var a = pctFor(n), b = pctFor(n + 1);
    var h = sec.querySelector('[data-iq-related-title]');
    if (h) h.textContent = b > a ? (a > 0 ? 'AÑADE UNA UNIDAD MÁS: TU DESCUENTO PASA DEL ' + a + '% AL ' + b + '%' : 'AÑADE UNA UNIDAD MÁS Y AHORRA UN ' + b + '%') : sec.dataset.defaultTitle;
  }
  var refreshTimer = null;
  var addBaseline = null;
  var addPending = false;
  var addNoticeTimer = null;
  function recordAddBaseline(e) {
    if (e.target && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"], product-form-component, [data-testid="standalone-add-to-cart"], .sticky-add-to-cart__button')) addBaseline = Number(IQ.cartCount) || 0;
  }
  document.addEventListener('click', recordAddBaseline, true);
  document.addEventListener('submit', recordAddBaseline, true);
  function hideAddNotice() {
    var notice = document.getElementById('iq-add-notice');
    if (notice) notice.remove();
    clearTimeout(addNoticeTimer);
  }
  function showAddNotice(count) {
    if (document.querySelector('cart-drawer-component[auto-open]')) return;
    hideAddNotice();
    var notice = document.createElement('div');
    notice.id = 'iq-add-notice';
    notice.className = 'iq-add-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    var title = document.createElement('strong');
    title.className = 'iq-add-notice__title';
    title.textContent = 'AÑADIDO AL CARRITO';
    var message = document.createElement('p');
    message.className = 'iq-add-notice__message';
    if (count < 4) message.textContent = 'AÑADE 1 PRENDA MÁS' + ': CON ' + (count + 1) + ' PRENDAS, ' + pctFor(count + 1) + '% DE DESCUENTO POR CANTIDAD.';
    else message.textContent = 'CON 4 O MÁS PRENDAS, 20% DE DESCUENTO POR CANTIDAD.';
    var note = document.createElement('small');
    note.className = 'iq-add-notice__note';
    note.textContent = 'Descuento automático. No acumulable con códigos.';
    var actions = document.createElement('div');
    actions.className = 'iq-add-notice__actions';
    var view = document.createElement('button');
    view.type = 'button';
    view.className = 'iq-add-notice__view';
    view.textContent = 'VER CARRITO';
    view.addEventListener('click', function () {
      hideAddNotice();
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) trigger.click(); else window.location.href = '/cart';
    });
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'iq-add-notice__close';
    close.setAttribute('aria-label', 'Cerrar aviso');
    close.textContent = '×';
    close.addEventListener('click', hideAddNotice);
    actions.appendChild(view);
    notice.appendChild(close);
    notice.appendChild(title);
    notice.appendChild(message);
    notice.appendChild(note);
    notice.appendChild(actions);
    document.body.appendChild(notice);
    addNoticeTimer = setTimeout(hideAddNotice, 9000);
  }
  function refreshCart() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var previous = addBaseline === null ? (Number(IQ.cartCount) || 0) : addBaseline;
          if (addPending && c.item_count > previous) showAddNotice(c.item_count);
          addPending = false;
          addBaseline = null;
          IQ.cartCount = c.item_count;
          if (c.item_count === 0) ss.del(RKEY);
          updateRelated(c);
        })
        .catch(function () { addPending = false; addBaseline = null; });
    }, 150);
  }
  ['cart:update', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, refreshCart); });
  /* Detecta cualquier petición al carrito (añadir, cambiar cantidades, eliminar) sin depender de eventos del tema */
  try {
    new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      var hit = entries.some(function (e) {
        return e.name.indexOf('/cart/') > -1 && /(add|change|update|clear)/.test(e.name);
      });
      var added = entries.some(function (e) { return e.name.indexOf('/cart/add') > -1; });
      if (added) { addPending = true; restartReserve(); }
      if (hit) refreshCart();
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}

  /* Aviso de unidades: se actualiza al cambiar de variante (mapa de variantes incluido en el bloque) */
  function updateScarcity(variantId, scope) {
    (scope || document).querySelectorAll('[data-iq-scarcity]').forEach(function (wrap) {
      var p = wrap.querySelector('.iq-scarcity');
      var raw = wrap.querySelector('[data-iq-scarcity-map]');
      if (!p || !raw) return;
      var map = {};
      try { map = JSON.parse(raw.textContent); } catch (e) { return; }
      var v = variantId != null ? map[String(variantId)] : null;
      p.hidden = !(v && v[0] === 1);
      p.classList.toggle('is-real', !!(v && v[1] === 1));
    });
  }
  document.addEventListener('shopify:product:select', function (e) {
    var d = e.detail || {};
    var scope = e.target && e.target.closest ? e.target.closest('.shopify-section') : null;
    updateScarcity(d.variantId, scope);
  });
  document.addEventListener('change', function (e) {
    var f = e.target && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"], product-form-component');
    if (!f) return;
    var id = f.querySelector('input[name="id"]');
    if (id) setTimeout(function () { updateScarcity(id.value, f.closest('.shopify-section')); }, 0);
  });

  /* Carrusel accesible de opiniones */
  function initCarousel(root) {
    if (root.dataset.iqReady) return;
    root.dataset.iqReady = '1';
    var track = root.querySelector('[data-iq-track]');
    var nav = root.querySelector('[data-iq-nav]');
    var prev = root.querySelector('[data-iq-prev]');
    var next = root.querySelector('[data-iq-next]');
    if (!track || !nav) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth; }
    function sync() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      nav.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    setTimeout(sync, 300);
  }
  document.querySelectorAll('[data-iq-carousel]').forEach(initCarousel);

  /* Enlace del resumen de valoraciones: lleva el foco a la sección de opiniones */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.iq-rating[href="#opiniones"]');
    if (!a) return;
    var t = document.getElementById('opiniones');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    t.focus({ preventScroll: true });
    setTimeout(fixWindow, 60);
  });

  /* Recomendaciones de Shopify para «relacionados» */
  var rel = document.querySelector('[data-iq-related]');
  if (rel && rel.dataset.url && window.fetch) {
    fetch(rel.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('[data-iq-related-grid]');
      var cur = rel.querySelector('[data-iq-related-grid]');
      if (g && cur && g.children.length >= 4) cur.innerHTML = g.innerHTML;
    }).catch(function () {});
  }

  /* Copiar código */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-iq-copy]');
    if (!b) return;
    var code = b.getAttribute('data-iq-copy');
    var done = function () { b.textContent = 'Copiado'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () { b.textContent = code; });
    else b.textContent = code;
  });

  /* Ajustes de accesibilidad sobre componentes de Horizon (se reaplican cuando el tema vuelve a pintar el carrito o la ficha) */
  function a11y() {
    document.querySelectorAll('caption[role="caption"]').forEach(function (c) { c.removeAttribute('role'); });
    document.querySelectorAll('button.slideshow-control[aria-selected]').forEach(function (b) {
      if (b.getAttribute('role') === 'tab') return;
      b.setAttribute('role', 'tab');
      var li = b.parentElement;
      if (li && li.tagName === 'LI') {
        li.setAttribute('role', 'presentation');
        if (li.parentElement) li.parentElement.setAttribute('role', 'tablist');
      } else if (li) {
        li.setAttribute('role', 'tablist');
      }
    });
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (b) {
      var label = b.disabled ? 'Agotado' : 'Añadir al carrito';
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    });
  }
  a11y();
  var a11yQueued = false;
  try {
    new MutationObserver(function () {
      if (a11yQueued) return;
      a11yQueued = true;
      requestAnimationFrame(function () { a11yQueued = false; a11y(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  } catch (e) {}

  /* Menú móvil: Escape lo cierra desde cualquier punto y, si se abre con el teclado, el foco entra en el panel */
  var viaKeyboard = false;
  document.addEventListener('mousedown', function () { viaKeyboard = false; }, true);
  document.addEventListener('keydown', function (e) {
    viaKeyboard = true;
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details.menu-drawer-container[open]');
    if (!d) return;
    var closeBtn = d.querySelector('.menu-drawer__close-button');
    if (closeBtn) closeBtn.click(); else d.removeAttribute('open');
    var sum = d.querySelector('summary');
    setTimeout(function () { if (sum) sum.focus(); }, 60);
  }, true);
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.menu-drawer-container') || !d.open || !viaKeyboard) return;
    setTimeout(function () {
      var f = d.querySelector('.menu-drawer__close-button') || d.querySelector('.menu-drawer a[href]');
      if (f && d.open) f.focus();
    }, 380);
  }, true);

  /* Newsletter: validación y origen del envío.
     Se valida al pulsar el botón o Intro, antes del envío, porque la protección antispam de Shopify intercepta el
     evento «submit» de los formularios de cliente y puede mostrar una verificación (hCaptcha) antes de suscribir. */
  var EMAIL = /^[^ @]+@[^ @]+[.][^ @]{2,}$/;
  function nlError(form) {
    var err = form.querySelector('[data-iq-error]');
    if (!err) {
      err = document.createElement('p');
      err.className = 'iq-nl__error';
      err.setAttribute('data-iq-error', '');
      err.setAttribute('role', 'alert');
      err.id = (form.id || 'IqNl') + 'Error';
      err.hidden = true;
      var row = form.querySelector('.iq-nl') || form.querySelector('input[type=email]');
      if (row && row.parentNode) row.parentNode.insertBefore(err, row.nextSibling); else form.appendChild(err);
    }
    if (!err.id) err.id = (form.id || 'IqNl') + 'Error';
    return err;
  }
  function nlCheck(form, e) {
    var input = form.querySelector('input[type=email]');
    if (!input) return true;
    var err = nlError(form);
    var ids = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (!EMAIL.test(input.value.trim())) {
      e.preventDefault();
      e.stopPropagation();
      err.textContent = input.value.trim() ? 'Introduce un correo electrónico válido (por ejemplo, nombre@correo.com).' : 'Escribe tu correo electrónico para suscribirte.';
      err.hidden = false;
      if (ids.indexOf(err.id) < 0) { ids.push(err.id); input.setAttribute('aria-describedby', ids.join(' ')); }
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return false;
    }
    input.removeAttribute('aria-invalid');
    err.hidden = true;
    ss.set('iq_nl_src', form.getAttribute('data-iq-nl'));
    return true;
  }
  document.querySelectorAll('form[data-iq-nl]').forEach(function (form) {
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.addEventListener('click', function (e) { nlCheck(form, e); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('input[type=email]')) nlCheck(form, e);
    });
    form.addEventListener('submit', function (e) { nlCheck(form, e); });
    var input = form.querySelector('input[type=email]');
    if (input) input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true' && EMAIL.test(input.value.trim())) {
        input.removeAttribute('aria-invalid');
        nlError(form).hidden = true;
      }
    });
  });

  var params = new URLSearchParams(location.search);
  var posted = params.get('customer_posted') === 'true';
  var src = ss.get('iq_nl_src') || (location.hash === '#IqPopupForm' ? 'popup' : (location.hash === '#IqFooterNewsletter' ? 'footer' : null));
  if (posted) {
    ss.del('iq_nl_src');
    params.delete('customer_posted');
    var q = params.toString();
    try { history.replaceState(null, '', location.pathname + (q ? '?' + q : '')); } catch (e) {}
  }
  if (posted && src === 'footer') {
    var ff = document.querySelector('form[data-iq-nl="footer"]');
    if (ff) {
      var ferr = ff.querySelector('[data-iq-nl-error]');
      var msg = ferr || ff.querySelector('[data-iq-nl-success]');
      if (msg) {
        msg.hidden = false;
        setTimeout(function () {
          var s = scroller();
          var top = msg.getBoundingClientRect().top - window.innerHeight / 2;
          if (s.scrollBy) s.scrollBy(0, top); else s.scrollTop += top;
          fixWindow();
        }, 200);
      }
      if (!ferr) ls.set('iq_popup_subscribed', '1');
    }
  }

  /* Ventana emergente de primera compra */
  var pop = document.getElementById('IqPopup');
  if (!pop) return;
  var lastFocus = null, locked = null;
  function focusables() {
    return [].slice.call(pop.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open(step) {
    pop.querySelectorAll('[data-iq-step]').forEach(function (s) { s.hidden = s.getAttribute('data-iq-step') !== step; });
    lastFocus = document.activeElement;
    pop.hidden = false;
    locked = scroller();
    locked.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var t = step === 'success' ? pop.querySelector('[data-iq-step="success"] h2') : pop.querySelector('input[type=email]');
    setTimeout(function () { (t || pop.querySelector('button')).focus({ preventScroll: true }); }, 40);
  }
  function close(remember) {
    if (pop.hidden) return;
    pop.hidden = true;
    if (locked) locked.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (remember) ls.set('iq_popup_closed', String(Date.now()));
    if (lastFocus && lastFocus.focus && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
  }
  pop.addEventListener('click', function (e) {
    if (e.target === pop || (e.target.closest && e.target.closest('[data-iq-popup-close]'))) close(true);
  });
  IQ.openPopup = function () { open('form'); };

  var serverErr = pop.querySelector('[data-iq-server-error="1"]');
  if (serverErr) {
    var perr = pop.querySelector('[data-iq-error]');
    if (perr) perr.hidden = false;
    open('form');
    return;
  }
  if (posted && src === 'popup') {
    ls.set('iq_popup_subscribed', '1');
    open('success');
    return;
  }
  var path = location.pathname;
  var blocked = ['/cart', '/checkout', '/account', '/challenge', '/policies', '/apps'].some(function (p) { return path.indexOf(p) === 0; }) || document.documentElement.classList.contains('shopify-design-mode');
  var closedAt = parseInt(ls.get('iq_popup_closed') || '0', 10);
  var days = parseInt(pop.getAttribute('data-days') || '7', 10);
  if (blocked || ls.get('iq_popup_subscribed') || (Date.now() - closedAt) < days * 864e5) return;
  var fired = false;
  var sc = scroller();
  var target = (sc === document.scrollingElement || sc === document.documentElement) ? window : sc;
  function fire() {
    if (fired) return;
    if (document.querySelector('dialog[open]:not(.chat-drawer), details.menu-drawer-container[open]')) { setTimeout(fire, 4000); return; }
    fired = true;
    target.removeEventListener('scroll', onScroll);
    open('form');
  }
  function onScroll() {
    var s = scroller();
    if ((s.scrollTop + s.clientHeight) / s.scrollHeight > 0.45) fire();
  }
  setTimeout(fire, parseInt(pop.getAttribute('data-delay') || '8', 10) * 1000);
  target.addEventListener('scroll', onScroll, { passive: true });
})();